/**
 * Customer-facing special-order lead time copy.
 *
 * @param {number|string|null|undefined} leadHours
 * @returns {string}
 */
export function specialOrderLeadTimeLabel (leadHours) {
    const hours = Number(leadHours);

    if (hours === 24) {
        return 'SPECIAL ORDER 1 DAY LEAD TIME';
    }

    if (hours === 72) {
        return 'SPECIAL ORDER 3 DAYS LEAD TIME';
    }

    return 'SPECIAL ORDER 2 DAYS LEAD TIME';
}

/**
 * Calendar days from today until the earliest ship date for a lead time.
 * Friday adds two extra days and Saturday adds one, so the weekend is skipped.
 *
 * @param {number|string|null|undefined} leadHours
 * @param {number} weekday Luxon weekday: Monday is 1, Sunday is 7
 * @returns {number}
 */
export function specialOrderLeadCalendarDays (leadHours, weekday) {
    const hours = Number(leadHours);
    let leadDays = 2;

    if (hours === 24) {
        leadDays = 1;
    } else if (hours === 72) {
        leadDays = 3;
    }

    if (weekday === 5) {
        return leadDays + 2;
    }

    if (weekday === 6) {
        return leadDays + 1;
    }

    return leadDays;
}

export function orderVisitDisplayName(order) {
    if (!order) {
        return '';
    }

    const customer = order.customer;
    const fromCustomer = customer?.name?.trim() || customer?.contact_name?.trim();
    if (fromCustomer) {
        return fromCustomer;
    }

    const parts = [order.shipping_first_name, order.shipping_last_name].filter(
        (part) => part != null && String(part).trim() !== ''
    );

    return parts.join(' ');
}

export function calculatePricingLevel (pricingLevel, cost, price) {
    let result = null;

    if (pricingLevel.modifier_type === 'fixed') {
        result = pricingLevel.modifier_amount;
    } else if (pricingLevel.modifier_type === 'cost_plus') {
        result = parseFloat(cost) + parseFloat(pricingLevel.modifier_amount);
    } else if (pricingLevel.modifier_type === 'percent_off_price') {
        const discount = price * (pricingLevel.modifier_amount / 100);
        result = price - discount;
    } else if (pricingLevel.modifier_type === 'margin') {
        const divisor = 1 - (pricingLevel.modifier_amount / 100);
        result = cost / divisor;
    }

    return result;
}